import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { ToasterService } from '@services/toaster.service'

@Component({
  selector: 'mh-toaster',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toaster.component.html',
  styleUrl: './toaster.component.scss',
})
export class ToasterComponent {
  private toasterService = inject(ToasterService)

  toasts = this.toasterService.getToasts

  close(id: string): void {
    this.toasterService.remove(id)
  }
}
